export default __webpack_public_path__ + "static/media/IBMNoThumbnailImage.4ebabc0b.svg";